export const REPORTING = 'reporting';
